import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { FileUploadControl, FileUploadValidators, FileUploadModule } from '@iplab/ngx-file-upload';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { FormErrorsComponent } from '@spartacus/storefront';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'knbr-kn-br-upload-new-template-dialog',
    templateUrl: './kn-br-upload-new-template-dialog.component.html',
    styleUrls: ['./kn-br-upload-new-template-dialog.component.scss'],
    imports: [ReactiveFormsModule, FormErrorsComponent, FileUploadModule, TranslatePipe]
})
export class KnBrUploadNewTemplateDialogComponent implements OnInit {
  public fileUploadControl = new FileUploadControl()
    .setListVisibility(false)
    .setValidators([FileUploadValidators.filesLimit(1), Validators.required]);
  documentTypes = '.csv';

  uploadTemplateForm: FormGroup = this.fb.group({
    templateName: ['', Validators.required],
  });

  constructor(
    protected activeModal: NgbActiveModal,
    protected fb: FormBuilder,
    protected knBrCommonService: KnBrCommonService
  ) {}

  ngOnInit(): void {}

  dismiss() {
    this.activeModal.dismiss();
  }

  upload() {
    if (this.uploadTemplateForm.valid && this.fileUploadControl.value.length > 0) {
      const formData: FormData = new FormData();
      formData.append('attachment', this.fileUploadControl.value[0]);
      this.knBrCommonService.createNacTemplate(this.uploadTemplateForm.controls.templateName.value, formData);
      this.activeModal.close(this.uploadTemplateForm.value);
    } else {
      this.uploadTemplateForm.markAllAsTouched();
    }
  }
}
